import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Accordion, AccordionTab } from "primereact/accordion";
import { EmptyFilter, Filter } from "./Filter";
import { format, toDate } from "date-fns";
import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { ILogin } from "../../models/Login";

export interface IBranchInvoiceConsultantWise {
    id: number,
    fromDate?: Date | null,
    toDate?: Date | null,
    consultant_ID?: number | null,
    consultant_Name?: string | null,
    vendor_Company_ID?: number | null,
    vendor_Company_Name?: string | null,
    paymentStatus?: string | null,
    payment_Date?: Date | null,
    is_Verified?: boolean | null,
    invoiceHours?: number | null,
    mRate?: number | null,
    invoiceAmount?: number | null,
    deduction?: number | null,
    deduction_Type?: number | null,
    branchInvoiceAmount?: number | null,
    percentage_Share?: number | null,
    branch_ID?: number | null,
    branchName?: string | null,
    company_ID?: number | null,
    company_Name?: string | null,
    receivedAmount?: number | null,
}

interface IProps {
    toast: any
}

export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IBranchInvoiceConsultantWise[], loading: boolean });
    const [selectedBranchWiseIncentive, setSelectedBranchWiseIncentive] = useState<IBranchInvoiceConsultantWise[]>([]);
    const [incentiveFilter, setIncentiveFilter] = useState(EmptyFilter);
    const dt = useRef<any>(null);
    const header = () => {
        return (
            <p>Branch Invoice List</p>
        );
    };
    const leftToolbarTemplate = () => {
        return <></>
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const generateInvoice = async () => {
        if (selectedBranchWiseIncentive.length > 0 && incentiveFilter.branchName !== undefined && incentiveFilter.branchName !== null && incentiveFilter.branchName.trim() !== "") {
            const newList: IBranchInvoiceConsultantWise[] = selectedBranchWiseIncentive.filter(e => (e.paymentStatus === "Paid" || e.paymentStatus === "Over Payment"));
            if (newList.length > 0) {
                setTableData({ tableData: tableData.tableData, loading: true });
                const response = await Fetch("InvoiceTracking/generatetBranchInvoiceConsultantWise", "PUT", newList.map(e => e.id), `branchName=${incentiveFilter.branchName}&companyID=${incentiveFilter.company}&dates=${new Date(incentiveFilter.month || "").toISOString().split("T")[0]}`, props.toast);
                if (response) {
                    props.toast.current.show({ severity: 'success', detail: 'Invoices Generated Successfully', life: 3000 });
                    loadTableData();
                } else {
                    setTableData({ tableData: tableData.tableData, loading: false });
                }
            } else {
                props.toast.current.show({ severity: 'error', detail: 'Must select atleast 1 PV invoice branch share with Payment Status : Paid / Over Payment', life: 3000 });
            }
        } else {
            props.toast.current.show({ severity: 'error', detail: 'Must select a branch from filter and atleast 1 incentive is selected', life: 3000 });
        }
    }

    const generateBranchInvoice = () => {
        confirmDialog({
            message: <p>Are you sure you want to generate invoice for selected PV invoices whose payment status is <span style={{ color: "red" }}>"Paid"</span> or <span style={{ color: "red" }}>"Over Payment"</span> ?</p>,
            // header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-success',
            accept: () => generateInvoice(),
            reject: () => { }
        });
    }

    const rightToolbarTemplate = () => {
        return <div className="flex gap-4">
            {selectedBranchWiseIncentive.length > 0 && (incentiveFilter.paymentStatus === undefined || incentiveFilter.paymentStatus === null) && (incentiveFilter.company !== undefined && incentiveFilter.company !== null && incentiveFilter.company !== 0 && incentiveFilter.branchName !== undefined && incentiveFilter.branchName !== null && incentiveFilter.branchName.trim() !== "") && <Button label="Generate Invoice" icon="pi pi-upload" className="p-button" onClick={generateBranchInvoice} />}
            {selectedBranchWiseIncentive.length > 0 && <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />}
        </div>
    }

    const loadTableData = async () => {
        setSelectedBranchWiseIncentive([]);
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("InvoiceTracking/getBranchIncentiveConsultantWise", "GET", null, `filter=${encodeURIComponent(JSON.stringify(incentiveFilter))}`, props.toast);
        if (response) {
            const data: IBranchInvoiceConsultantWise[] = await response.json();
            setTableData({
                tableData: data.map((el: any) => {
                    let dateFrom, dateTo, datePayment;

                    if (el.fromDate) dateFrom = format(new Date(el.fromDate), 'dd/MM/yyyy').toUpperCase();
                    else dateFrom = "";

                    if (el.toDate) dateTo = format(new Date(el.toDate), 'dd/MM/yyyy').toUpperCase();
                    else dateTo = "";

                    if (el.payment_Date) datePayment = format(new Date(el.payment_Date), 'dd/MM/yyyy').toUpperCase();
                    else datePayment = "";

                    return { ...el, fromDate: dateFrom, toDate: dateTo, payment_Date: datePayment, sales_Branch: (el.sales_Branch + " (" + el.sales_Comp.split(" ")[0] + ")"), recruiter_Branch: (el.recruiter_Branch + " (" + el.recruiter_Comp.split(" ")[0] + ")") };
                }), loading: false
            });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    }

    useEffect(() => {
        loadTableData();
    }, [incentiveFilter]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj?.date_Format;
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter incentiveFilter={incentiveFilter} setIncentiveFilter={setIncentiveFilter} toast={props.toast} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="65vh"
                dataKey="id"
                value={tableData.tableData}
                emptyMessage="No Branches found."
                header={header}
                loading={tableData.loading}
                selectionMode={'checkbox'}
                selection={selectedBranchWiseIncentive}
                onSelectionChange={(e) => {
                    const value = e.value as IBranchInvoiceConsultantWise[];
                    setSelectedBranchWiseIncentive(value);
                }}
                paginator
                rows={100}
                rowsPerPageOptions={[5, 10, 20, 50, 100]}
            >
                <Column style={{ minWidth: '3rem', maxWidth: '3rem' }} selectionMode="multiple" />
                <Column field="sn" header="SN" style={{ minWidth: '3rem', maxWidth: '3rem' }} body={(rowData, options) => options.rowIndex + 1} />
                {/* <Column field="fromDate" header="From Date" />
                <Column field="toDate" header="To Date" /> */}
                 <Column field="fromDate" header="From Date" body={(rowData: any) => safeFormatDate(rowData.fromDate, "dd/MM/yyyy", DateFormat)}/>
                <Column field="toDate" header="To Date" body={(rowData: any) => safeFormatDate(rowData.toDate, "dd/MM/yyyy", DateFormat)}/>
                <Column field="company_Name" header="Company" />
                <Column field="branchName" header="Branch" />
                <Column field="sales_Branch" header="Sales Branch (Comp)" />
                <Column field="recruiter_Branch" header="Recruiter Branch (Comp)" />
                <Column field="consultant_Name" header="Consultant Name" />
                <Column field="vendor_Company_Name" header="Client Company" />
                <Column field="invoiceAmount" header="Invoice Amount $" />
                <Column field="paymentStatus" header="Payment Status" body={(rowData: any) => <p>{rowData.paymentStatus === null ? "Pending" : rowData.paymentStatus}</p>} />
                {/* <Column field="payment_Date" header="Payment Date" /> */}
                <Column field="payment_Date" header="Payment Date"  body={(rowData: any) =>safeFormatDate(rowData.payment_Date, "dd/MM/yyyy", DateFormat)}/>
                {/* <Column field="is_Verified" header="is_Verified" /> */}
                <Column field="invoiceHours" header="Hours" />
                <Column field="mRate" header="Margin" />
                <Column field="deduction" header="Deduction" />
                {/* <Column field="net_Amount" header="Net Amount $" /> */}
                <Column field="percentage_Share" header="Share %" />
                <Column field="branchInvoiceAmount" header="Branch Share $" body={(rowData: IBranchInvoiceConsultantWise) => <p>{(rowData.deduction_Type === 1 ? ((rowData.branchInvoiceAmount || 0) - ((((rowData?.deduction || 0) * (rowData.mRate || 0)) / 100) * (rowData.invoiceHours || 0))) : (rowData.deduction_Type === 2 ? ((rowData.branchInvoiceAmount || 0) - (((rowData.mRate || 0) - (rowData.deduction || 0)) * (rowData.invoiceHours || 0))) : (rowData.branchInvoiceAmount || 0)))}</p>} />
            </DataTable>
            <ConfirmDialog />
        </>
    );
}